var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-dialog1" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "modal-append-to-body": false,
            visible: _vm.isVisible,
            width: "400px",
            "custom-class": "uni-custom-dialog",
            center: "",
            top: "25vh",
            "close-on-click-modal": _vm.modal,
            "show-close": _vm.showClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isVisible = $event
            },
            close: _vm.updateVisible,
          },
        },
        [
          _c("div", { staticClass: "content", class: _vm.iconPosition }, [
            _vm.icon == "success"
              ? _c("i", { staticClass: "icon success" })
              : _vm.icon == "fail"
              ? _c("i", { staticClass: "icon fail" })
              : _vm.icon == "account"
              ? _c("i", { staticClass: "icon account" })
              : _vm._e(),
            _vm.title
              ? _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))])
              : _vm._e(),
            _vm.tips
              ? _c("div", {
                  staticClass: "tips",
                  domProps: { innerHTML: _vm._s(_vm.tips) },
                })
              : _vm._e(),
            _vm.score != undefined
              ? _c("div", { staticClass: "score-row" }, [
                  _c("span", { staticClass: "score" }, [
                    _vm._v(_vm._s(_vm.score)),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.title === "本次练习正确率为" ? "" : "分") +
                      " "
                  ),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.showCancelBtn
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      class: _vm.cancelClass,
                      on: { click: _vm.cancel },
                    },
                    [_vm._v(_vm._s(_vm.cancelText))]
                  )
                : _vm._e(),
              _vm.showConfirmBtn
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      class: _vm.confirmClass,
                      attrs: { type: "primary" },
                      on: { click: _vm.confirm },
                    },
                    [_vm._v(_vm._s(_vm.confirmText))]
                  )
                : _vm._e(),
              _vm.showConfirmCzBtn
                ? _c(
                    "el-button",
                    { staticClass: "btn", on: { click: _vm.confirmCz } },
                    [_vm._v(_vm._s(_vm.confirmCzText))]
                  )
                : _vm._e(),
              _vm.showConfirmNextBtn
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.confirmNext },
                    },
                    [_vm._v(_vm._s(_vm.confirmNextText))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }